/**
 * Side Popup Link - Frontend JavaScript
 * Handles opening side popup when clicking on the link
 */
(function () {
	'use strict';

	// Initialize when DOM is ready
	document.addEventListener('DOMContentLoaded', function () {
		initSidePopupLinks();
	});

	function initSidePopupLinks() {
		// Handle clicks on side-popup-link blocks
		document.addEventListener('click', function (e) {
			const link = e.target.closest('.wp-block-matat-pandora-side-popup-link');
			if (!link) return;

			e.preventDefault();

			// Support both regular and base64-encoded shortcode (for TinyMCE inserted links)
			let shortcode = link.dataset.shortcode;
			if (!shortcode && link.dataset.shortcodeEncoded) {
				try {
					shortcode = decodeURIComponent(escape(atob(link.dataset.shortcodeEncoded)));
				} catch (err) {
					console.error('Failed to decode shortcode:', err);
				}
			}
			const title = link.dataset.title;

			if (shortcode) {
				openSidePopup(shortcode, title);
			}
		});

		// Handle sidebar close
		document.addEventListener('click', function (e) {
			if (e.target.closest('.side-popup-close')) {
				closeSidePopup();
			}
		});

		// Handle overlay clicks
		document.addEventListener('click', function (e) {
			const overlay = e.target.closest('.side-popup-overlay');
			if (overlay && !e.target.closest('.side-popup') && !e.target.closest('.wp-block-matat-pandora-side-popup-link')) {
				closeSidePopup();
			}
		});

		// Handle ESC key
		document.addEventListener('keydown', function (e) {
			if (e.keyCode === 27) {
				closeSidePopup();
			}
		});
	}

	function openSidePopup(shortcode, title) {
		// Create sidebar if it doesn't exist
		if (!document.querySelector('.side-popup-overlay')) {
			createSidePopup();
		}

		const overlay = document.querySelector('.side-popup-overlay');
		const sidebar = document.querySelector('.side-popup');
		const content = document.querySelector('.side-popup-content');
		const titleEl = document.querySelector('.side-popup-title');

		// Update title immediately (before loading)
		if (titleEl) {
			titleEl.textContent = title || '';
		}

		// Show loading state with GIF
		const loaderUrl = (typeof matatFeatureIcons !== 'undefined' && matatFeatureIcons.loaderUrl)
			? matatFeatureIcons.loaderUrl
			: '/wp-content/themes/pandora-by-matat/assets/images/loading-gif.gif';
		content.innerHTML = '<div class="side-popup-loading" style="display:flex;justify-content:center;align-items:center;padding:40px;"><img src="' + loaderUrl + '" alt="Loading..." style="width:50px;height:auto;" /></div>';

		overlay.classList.add('active');

		setTimeout(function () {
			sidebar.classList.add('active');
			document.body.classList.add('side-popup-open');
		}, 1);

		// Load content (pass title to preserve it)
		loadSidePopupContent(shortcode, title);
	}

	function closeSidePopup() {
		const overlay = document.querySelector('.side-popup-overlay');
		const sidebar = document.querySelector('.side-popup');

		if (sidebar) sidebar.classList.remove('active');

		setTimeout(function () {
			if (overlay) overlay.classList.remove('active');
			document.body.classList.remove('side-popup-open');
		}, 1);
	}

	function createSidePopup() {
		const loaderUrl = (typeof matatFeatureIcons !== 'undefined' && matatFeatureIcons.loaderUrl)
			? matatFeatureIcons.loaderUrl
			: '/wp-content/themes/pandora-by-matat/assets/images/loading-gif.gif';

		const overlay = document.createElement('div');
		overlay.className = 'side-popup-overlay feature-sidebar-overlay';
		overlay.innerHTML = `
			<div class="side-popup feature-sidebar">
				<div class="side-popup-header feature-sidebar-header">
					<h3 class="side-popup-title feature-sidebar-title"></h3>
					<button class="side-popup-close feature-sidebar-close">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" role="img">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M19.1925 19.8996L0.100586 0.807693L0.807693 0.100586L19.8996 19.1925L19.1925 19.8996Z"></path>
							<path fill-rule="evenodd" clip-rule="evenodd" d="M0.100586 19.1925L19.1925 0.100586L19.8996 0.807693L0.807693 19.8996L0.100586 19.1925Z"></path>
						</svg>
					</button>
				</div>
				<div class="side-popup-content feature-sidebar-content">
					<div class="side-popup-loading" style="display:flex;justify-content:center;align-items:center;padding:40px;"><img src="${loaderUrl}" alt="Loading..." style="width:50px;height:auto;" /></div>
				</div>
			</div>
		`;

		document.body.appendChild(overlay);
	}

	function loadSidePopupContent(shortcode, title) {
		const content = document.querySelector('.side-popup-content');
		const titleEl = document.querySelector('.side-popup-title');

		// Get REST URL from wp_localize_script or construct it
		let restUrl = '/wp-json/';
		if (typeof matatFeatureIcons !== 'undefined' && matatFeatureIcons.restUrl) {
			restUrl = matatFeatureIcons.restUrl;
		} else if (typeof wpApiSettings !== 'undefined' && wpApiSettings.root) {
			restUrl = wpApiSettings.root;
		}

		const apiUrl = restUrl + 'matat-feature-icons/v1/shortcode-content?shortcode=' + encodeURIComponent(shortcode);

		fetch(apiUrl)
			.then(function (response) {
				return response.json();
			})
			.then(function (data) {
				if (data.content) {
					content.innerHTML = data.content;
					// Only update title from API if no title was provided from data-title
					if (titleEl && !title && data.title) {
						titleEl.textContent = data.title;
					}
				} else {
					content.innerHTML = '<div class="side-popup-error"><p>Unable to load content. Please try again later.</p></div>';
				}
			})
			.catch(function () {
				content.innerHTML = '<div class="side-popup-error"><p>Unable to load content. Please try again later.</p></div>';
			});
	}
})();
